import { Dispatch } from "react";
import { AppState } from "./configureStore";
import { createSlice, PayloadAction, AnyAction } from '@reduxjs/toolkit';
import { client } from "../App";
import { GetApplicationTimeoutResponse, GetApplicationTimeout } from "../DCR.dtos";
import { IEnumLoadableState, DataLoadState } from "../definitions/IEnumLoadableState";

export interface ITimeoutState extends IEnumLoadableState {
    logoffMinutes: number;
    logoffWarningMinutes: number;
}

export interface IApplicationTimeoutState {
    applicationTimeout: ITimeoutState;
}

export const initialApplicationTimeout: IApplicationTimeoutState = {
    applicationTimeout: {
        loadState: DataLoadState.None,
        logoffMinutes: 0,
        logoffWarningMinutes: 0
    } as ITimeoutState
};



const slice = createSlice({
    name: 'applicationTimeout',
    initialState: initialApplicationTimeout,
    reducers: {
        resetState: () => {
            return {
                ...initialApplicationTimeout
            }
        },
        requestApplicationTimeoutData: (state: IApplicationTimeoutState) => {
            return {
                ...state,
                applicationTimeout: {
                    ...state.applicationTimeout,
                    loadState: DataLoadState.Loading
                }
            }
        },
        receiveApplicationTimeoutData: (state: IApplicationTimeoutState, action: PayloadAction<{ getApplicationTimeoutResponse: GetApplicationTimeoutResponse }>) => {
            const { getApplicationTimeoutResponse } = action.payload;
            return {
                ...state,
                applicationTimeout: {
                    ...state.applicationTimeout,
                    logoffMinutes: getApplicationTimeoutResponse.logoffMinutes,
                    logoffWarningMinutes: getApplicationTimeoutResponse.logoffWarningMinutes,
                    loadState: DataLoadState.Loaded
                }
            }
        },
        receiveApplicationTimeoutDataError: (state: IApplicationTimeoutState) => {
            return {
                ...state,
                manageContributions: {
                    ...state.applicationTimeout,
                    loadState: DataLoadState.Error
                }
            }
        }

    }
})

const { resetState,
    requestApplicationTimeoutData,
    receiveApplicationTimeoutData,
    receiveApplicationTimeoutDataError
} = slice.actions;

function fetchApplicationTimeout() {
    return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
        const { loadState } = getState().applicationTimeout.applicationTimeout;
        if (loadState === DataLoadState.Loaded || loadState === DataLoadState.Loading) {
            return;
        }

        dispatch(requestApplicationTimeoutData());

        try {

            const getApplicationTimeoutResponse = await client.get(new GetApplicationTimeout());

            dispatch(receiveApplicationTimeoutData({ getApplicationTimeoutResponse }));

        } catch (e) {
            dispatch(receiveApplicationTimeoutDataError());
            console.log(e);
        }

    }
}

export const applicationTimeoutActionCreators = {
    fetchApplicationTimeout,
    resetState
};

export const applicationTimeoutReducer = slice.reducer;